const weatherLayerReducer = (state = '', action) => {
  switch (action.type) {
    case 'SET_WEATHER_LAYER':
      return action.payload;
    default:
      return state;
  }
};
export default weatherLayerReducer;
